module.exports = __webpack_public_path__ + "assets/76e6526019e3d3cf1dacb387fdf700da.png";